import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "senarai_pegawai",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pb-0 border-0" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative ps-5" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_10 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTDatatable = _resolveComponent("KTDatatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, " Senarai Pegawai Layak (" + _toDisplayString(_ctx.calonList.length) + ") ", 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "data-kt-subscription-table-filter": "search",
            class: "form-control form-control-solid w-250px ps-14",
            placeholder: "Carian",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event))
          }, null, 512), [
            [_vModelText, _ctx.search]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_KTDatatable, {
            "table-data": _ctx.calonList,
            "table-header": _ctx.headerConfig,
            "enable-items-per-page-dropdown": false,
            total: _ctx.calonList.length
          }, {
            "cell-nama_penuh": _withCtx(({ row: pemohon }) => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(pemohon.nama_penuh), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(pemohon.no_kad_pengenalan), 1)
            ]),
            "cell-emel": _withCtx(({ row: pemohon }) => [
              _createElementVNode("div", _hoisted_13, _toDisplayString(pemohon.emel), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(pemohon.no_telefon_bimbit), 1)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "total"])
        ])
      ])
    ])
  ]))
}